import { Component, OnInit } from '@angular/core';
import * as async from 'async';
import * as _ from 'underscore';
import { FormArray, FormControl, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { GuardConfirmModalComponent } from 'src/app/components/modals/guard-confirm-modal/guard-confirm-modal.component';
import { Router } from '@angular/router';
import { TranslateService } from '@devinforius/i-essentials';
import { ServicesService } from 'src/app/shared/services/services.service';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { ServiceDto } from 'src/app/shared/interfaces';
import { UsersService } from 'src/app/shared/services/users.service';
import { FilesService } from 'src/app/shared/services/files.service';
import {
  MailsFilesAcceptValidationParams,
  MailsFilesRefuseValidationParams,
  MailsFilesRefuseValidationParamsFiles,
} from 'src/app/shared/models/mails/mail-file';
import { MailValidationFiles } from 'src/app/shared/models/mails/mail-validation';
import { Cols } from 'src/app/shared/models/cols';
import { environment } from 'src/environments/environment';
import { setServiceDescription } from 'src/app/utils/set-service-description.utils';

@Component({
  selector: 'app-document-to-validate',
  templateUrl: './document-to-validate.component.html',
  styleUrls: ['./document-to-validate.component.scss'],
})
export class DocumentToValidateComponent implements OnInit {
  public columns: Cols[] = [];
  public forselection: { click: (value: MailValidationFiles[]) => void; label: string; tooltip: string }[] = [
    {
      click: (selections) => {
        this.validateWithoutComment(selections);
      },
      label: 'Validation sans commentaire',
      tooltip: '',
    },
    {
      click: (selections) => {
        this.validateModal(selections);
      },
      label: 'Validation avec commentaire',
      tooltip: '',
    },
    {
      click: (selections) => {
        this.refuse(selections);
      },
      label: 'Refus',
      tooltip: '',
    },
  ];
  public files: MailValidationFiles[] = [];
  public fileToShow: MailValidationFiles = null;
  public refuseModal: boolean = false;
  public formModal = new FormGroup({
    files: new FormArray([], Validators.required),
  });
  public formAccept = new FormGroup({
    justification: new FormControl(null),
    dateRefus: new FormControl(new Date()),
  });
  public refuseItems: MailValidationFiles[] = [];
  public columnsRefuse: Cols[] = [
    {
      field: 'ordre',
      header: 'Ordre',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'defaultRoleName',
      header: 'Rôle',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'serviceLabel',
      header: 'Service',
      format: (_val, item) => {
        if (item.serviceId) {
          let temp = [];
          temp = this.services.filter((service) => service.id === item.serviceId);

          if (temp.length > 0) {
            return _.first(temp).description;
          }
        } else {
          return 'Pas de service';
        }
      },
    },
  ];
  public services: ServiceDto[] = [];
  public contacts: { label: string; value: number }[] = [];
  public showValidateModal: boolean = false;
  public itemsToValidate: MailValidationFiles[] = [];
  public formDisabled: boolean = true;
  public menuSelection: { label: string; icon: string; command: (value: MailValidationFiles) => void }[] = [
    {
      label: 'Nouvelle version',
      icon: 'pi pi-pencil',
      command: (item) => {
        this.newVersion(item);
      },
    },
  ];
  constructor(
    public translater: TranslateService,
    public formbuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    public spinner: NgxSpinnerService,
    public confirmService: ConfirmationService,
    public dialogService: DialogService,
    public router: Router,
    private servicesService: ServicesService,
    private contactsService: ContactsService,
    private usersService: UsersService,
    private filesService: FilesService
  ) {}
  ngOnInit(): void {
    this.getFilesToValidate();
    this.getServices();
    this.getContact();
    this.columns = [
      {
        field: 'mailId',
        header: 'ID',
        format: (value: number): number => {
          return value;
        },
        click: (value) => {
          this.goTo(value.mailId);
        },
      },
      {
        field: 'objet',
        header: 'Objet',
        format: (value: string): string => {
          return value;
        },
      },
      {
        field: 'serviceLabel',
        header: 'Service',
        format: (value: string): string => {
          return value;
        },
      },
      {
        field: 'documentName',
        header: 'Document',
        format: (value: string): string => {
          return value;
        },
      },
      {
        field: 'dateUpload',
        header: 'Création',
        format: (value: string): string => {
          if (value) {
            return moment(value).format('DD/MM/YYYY à HH:mm');
          } else return '';
        },
        sort: (a, b, order) => {
          const val1 = moment(a, 'DD/MM/YYYY à HH:mm').isValid() ? moment(a, 'DD/MM/YYYY à HH:mm').unix() : null;
          const val2 = moment(b, 'DD/MM/YYYY à HH:mm').isValid() ? moment(b, 'DD/MM/YYYY à HH:mm').unix() : null;
          if (val1 === null) return 1;
          else if (val2 === null) return -1;
          else return val1 < val2 ? 1 * order : -1 * order;
        },
        sortable: true,
      },
    ];
    this.formModal.statusChanges.subscribe({
      next: (res) => {
        if (res === 'VALID') {
          this.formDisabled = false;
        } else {
          this.formDisabled = true;
        }
      },
    });
  }

  get filess(): FormArray {
    return this.formModal.get('files') as FormArray;
  }

  getFilesToValidate(): void {
    this.files = [];
    this.spinner.show();
    this.filesService.getAllFilesToValidate().subscribe({
      next: (res) => {
        if (res.length > 0) {
          res.map((item) => {
            this.files.push({
              mailId: item.mail.id,
              objet: item.mail.objet,
              serviceId: item.mail.serviceProprietaireId,
              serviceLabel: item.mail.serviceProprietaire ? item.mail.serviceProprietaire.description : '',
              documentName: item.file.description + '.' + item.file.extension,
              dateUpload: item.file.dateUpload,
              name: item.file.description,
              extension: item.file.extension,
              id: item.file.id,
              version: item.file.version,
              addNewVersion: item.canAddVersion,
              createdByUserId: item.mail.createdByUserId,
            });
          });
        }
        this.files = [...this.files];
        this.spinner.hide();
      },
      error: (err) => {
        console.error(err);
        this.spinner.hide();
      },
    });
  }

  getServices(): void {
    this.servicesService.fetchServices().subscribe({
      next: (res: ServiceDto[]) => {
        this.services = res.map((service) => ({
          ...service,
          description: setServiceDescription(service),
        }));
      },
    });
  }

  getContact(): void {
    this.contactsService.getLowInformationsContactsiCourrier().subscribe({
      next: (response) => {
        this.contacts = [];
        if (response.length > 0) {
          response.map((contact) => {
            if (contact) {
              this.contacts.push({
                label: (contact.prenom ? contact.prenom : '') + ' ' + (contact.nom ? contact.nom : ''),
                value: contact.id,
              });
            }
          });
        }
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }

  validateModal(items: MailValidationFiles[]): void {
    this.showValidateModal = true;
    this.itemsToValidate = [];
    this.itemsToValidate = items;
  }

  validate(): void {
    const files: MailsFilesAcceptValidationParams['files'] = [];
    this.spinner.show();

    if (this.itemsToValidate.length > 0) {
      this.itemsToValidate.map((item) => {
        files.push({
          fileId: item.id,
          justification: this.formAccept.value.justification,
        });
      });

      const data: MailsFilesAcceptValidationParams = {
        files: files,
      };

      if (data.files.length > 0) {
        this.filesService.putAcceptValidation(data).subscribe({
          next: () => {
            this.toastr.success('Validation effectuée avec succès!');
            this.spinner.hide();
            this.showValidateModal = false;
            window.location.reload();
          },
          error: (err) => {
            console.error(err);
            this.spinner.hide();
            this.toastr.error("La validation n'a pas pu se produire");
          },
        });
      }
    }
  }

  validateWithoutComment(items: MailValidationFiles[]): void {
    const files: MailsFilesAcceptValidationParams['files'] = [];
    this.spinner.show();

    if (items.length > 0) {
      items.map((item) => {
        files.push({
          fileId: item.id,
        });
      });

      const data: MailsFilesAcceptValidationParams = {
        files: files,
      };

      if (data.files.length > 0) {
        this.filesService.putAcceptValidation(data).subscribe({
          next: () => {
            this.toastr.success('Validation effectuée avec succès!');
            this.spinner.hide();
            window.location.reload();
          },
          error: (err) => {
            console.error(err);
            this.spinner.hide();
            this.toastr.error("La validation n'a pas pu se produire");
          },
        });
      }
    }
  }
  refuse(items: MailValidationFiles[]): void {
    const control = this.formModal.get('files') as UntypedFormArray;
    control.clear(); // On clear pour être sûr.

    this.refuseItems = items;

    this.getAllPreviousSteps(control);
  }

  private getAllPreviousSteps(control: UntypedFormArray): void {
    // En premier lieu on va récupérer tous les steps précédent de chaque fichier
    async.eachSeries(
      this.refuseItems,
      (item, cbEachSeries) => {
        this.filesService.getPreviousValidation(item.mailId, item.id).subscribe({
          next: (res) => {
            item.previousStep = res.sort((a, b) => a.ordre - b.ordre);
            item.doesAPreviousStepExists = res.some((step) => step.id === -1);
            control.push(
              this.formbuilder.group({
                fileId: new UntypedFormControl(item.id, Validators.required),
                previousStepId: new UntypedFormControl(null, Validators.required),
                previousStepName: new UntypedFormControl(null, Validators.required),
                contactId: item.doesAPreviousStepExists ? new UntypedFormControl(null, Validators.required) : new UntypedFormControl(null),
                justification: new UntypedFormControl(null),
                name: new UntypedFormControl(item.documentName),
              })
            );
            cbEachSeries();
          },
        });
      },
      () => {
        this.getAllContactsForEachStep(control);
      }
    );
  }

  private getAllContactsForEachStep(control: UntypedFormArray): void {
    //Ensuite on va parcourir chaque fichier et s'il y a min 1 étape précédente, on va récupérer les contacts du service du courrier (! chaque fichier peut être lié a un courrier !== )
    async.eachSeries(
      this.refuseItems,
      (refuseItem, cbEachSeries) => {
        if (refuseItem.doesAPreviousStepExists) {
          this.servicesService.fetchServiceUsersIds(refuseItem.serviceId).subscribe({
            next: (usersByServiceId: number[]) => {
              refuseItem.contacts = [];
              if (usersByServiceId.length > 0) {
                const data = {
                  UserIds: usersByServiceId.join(','),
                };
                this.usersService.getUserWithData(data).subscribe({
                  next: (usersWithData) => {
                    if (usersWithData?.length > 0) {
                      usersWithData.map((userWithData) => {
                        refuseItem.contacts.push({
                          label:
                            (userWithData.contactForUser.prenom ? userWithData.contactForUser.prenom : '') +
                            ' ' +
                            (userWithData.contactForUser.nom ? userWithData.contactForUser.nom : ''),
                          value: userWithData.contactForUser.contactId,
                          userId: userWithData.userId,
                        });
                      });
                    }
                    cbEachSeries(null);
                  },
                  error: (error) => {
                    console.error(error);
                    this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingUsers'));
                  },
                });
              } else {
                cbEachSeries();
              }
            },
            error: (error) => {
              console.error(error);
              this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingUsersByServiceId'));
            },
          });
        } else {
          refuseItem.contacts = [];
          cbEachSeries();
        }
      },
      () => {
        this.patchRefuseItems(control);
      }
    );
  }

  private patchRefuseItems(control: UntypedFormArray): void {
    // Ensuite on va faire le dernier patch de données => le contactId qui se patch automatiquement
    //  Le contactId dépend de 2 choses : doesAPreviousStepExists (=> si on doit avoir un gestionnaire) ET si l'utilisateur existe dans la liste

    this.refuseItems.forEach((item, index) => {
      const creatorOfTheMailIdExistsInList = item.contacts?.find((contact) => +contact.userId === +item.createdByUserId);
      control.at(index).patchValue({
        contactId: item.doesAPreviousStepExists ? (creatorOfTheMailIdExistsInList?.value ? creatorOfTheMailIdExistsInList.value : null) : null,
      });
    });
    this.refuseModal = true;
  }

  submitRefuse(): void {
    this.spinner.show();
    if (this.formModal.valid) {
      async.eachSeries(
        this.formModal.value.files,
        (item: MailsFilesRefuseValidationParamsFiles, cbEachSeries) => {
          if (item?.contactId) {
            this.contactsService.fetchContactsRemplacantsiCourrier([item.contactId]).subscribe({
              next: (res) => {
                const hasAbsentPeopleArray = [];

                if (res?.length > 0) {
                  res.map((remplacant) => {
                    if (remplacant.absent === true && item.contactId === remplacant.contactId) {
                      hasAbsentPeopleArray.push(remplacant);
                    }
                  });
                }

                if (hasAbsentPeopleArray.length > 0) {
                  this.confirmService.confirm({
                    message: 'Souhaitez-vous remplacer automatiquement les personnes qui sont en congés pour le fichier ' + item.name + ' ?',
                    key: 'remplacantDocumentToValidate',
                    accept: () => {
                      item.contactId = hasAbsentPeopleArray[0].remplaceParContactId;
                      cbEachSeries(null);
                    },
                    reject: () => {
                      cbEachSeries(null);
                    },
                  });
                } else {
                  cbEachSeries(null);
                }
              },
            });
          } else {
            cbEachSeries();
          }
        },
        () => {
          const params: MailsFilesRefuseValidationParams = {
            files: this.formModal.value.files,
          };
          this.filesService.putRefuseValidation(params).subscribe({
            next: () => {
              this.toastr.success('Validation refusée avec succès!');
              this.refuseModal = false;
              this.getFilesToValidate();
            },
            error: (err) => {
              console.error(err);
              this.spinner.hide();
              this.toastr.error("La validation n'a pas pu se produire");
            },
          });
        }
      );
    } else {
      this.toastr.warning('Des champs requis ne sont pas complétés');
      this.spinner.hide();
    }
  }

  openFile(item: MailValidationFiles): void {
    this.fileToShow = null;
    this.fileToShow = item;
    this.spinner.show();
  }

  select(item, index: number): void {
    this.filess.at(index).patchValue({
      previousStepId: item.id,
      previousStepName: item.ordre + ' - ' + item.defaultRoleName + ' - ' + item.serviceLabel,
      contactId: item.id !== -1 ? item.historiqueMostRecent?.fromContactId : this.filess.at(index).value.contactId,
    });
  }

  goTo(mailId): void {
    const url = '/private/ic/tabs/';
    const config = environment;
    window.open(config.baseUrl + url + mailId);
  }

  newVersion(item): void {
    if (item.addNewVersion) {
      const ref = this.dialogService.open(GuardConfirmModalComponent, {
        header: 'Confirmation',
        styleClass: 'super-compos-modal-content ',
        dismissableMask: false,
        width: '30em',
        data: {
          message: 'Voulez-vous créer une nouvelle version ?',
        },
      });

      ref.onClose.subscribe({
        next: (value) => {
          if (value) {
            if (value === true) {
              this.router.navigate(['/private/ic/editor/' + item.mailId + '/file/' + item.id]);
            }
          }
        },
      });
    } else {
      this.toastr.warning('Ce fichier ne peut pas avoir de nouvelle version');
    }
  }
}
